import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import './Dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard-wrapper">
      <Navbar />
      <div className="dashboard-body">
        <Sidebar />
        <div className="dashboard-content">
          <div className="welcome-box">
            <h2>Welcome to <span>SportsDuniya Dashboard</span> 🎯</h2>
            <p>Manage News, Payouts, Analytics, and more with a few clicks.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
